import { useMemo } from 'react';

import { useLatest } from 'lib/hooks/useLatest';
import { usePageChrome } from 'lib/hooks/usePageChrome';

const shapeOf = (action) =>
  action && {
    label: action.label,
    icon: action.icon || null,
    disabled: !!action.disabled,
    permission: action.permission || null,
    options: action.options?.map((option) => ({
      label: option.label,
      icon: option.icon || null,
      disabled: !!option.disabled,
      permission: option.permission || null
    }))
  };

/**
 * Pass null when the page creates nothing. `permission` takes Allowed's props.
 *
 * @param {{ label: string, icon?: string, onClick?: Function, disabled?: boolean,
 *   permission?: object, options?: { label: string, icon?: string, onClick: Function,
 *   permission?: object }[] } | null} action
 */
export const usePageCreateAction = (action) => {
  const latest = useLatest(action);
  const key = action?.label ? JSON.stringify(shapeOf(action)) : null;

  // Only the action's shape is compared; its handlers are read when picked, so a page that
  // re-renders never re-registers.
  const chrome = useMemo(() => {
    if (!key) return null;
    const shape = JSON.parse(key);
    return {
      createAction: {
        ...shape,
        onClick: () => latest.current?.onClick?.(),
        options: shape.options?.map((option, index) => ({
          ...option,
          onClick: () => latest.current?.options?.[index]?.onClick?.()
        }))
      }
    };
  }, [key, latest]);

  return usePageChrome(chrome);
};
